import { createQueryKeyStore } from '@lukemorales/query-key-factory';
import { AxiosInstance } from 'axios';

import { API_PREFIX_ADMIN } from '../../../constants.ts';

import { TAdminAppointmentsPayload, TAdminAppointmentsResponse } from './types.ts';

export class AdminApiAppointmentsService {
    #QUERY_KEYS = createQueryKeyStore({
        appointments: {
            list: (payload: TAdminAppointmentsPayload) => ({
                queryKey: ['admin-appointments', payload],
                queryFn: () => this.#getAppointments(payload),
            }),
        },
    });

    constructor(private api: AxiosInstance) {
        this.api = api;
    }

    getAppointments(payload: TAdminAppointmentsPayload) {
        return this.#QUERY_KEYS.appointments.list(payload);
    }

    async #getAppointments(
        payload: TAdminAppointmentsPayload
    ): Promise<TAdminAppointmentsResponse> {
        const { data } = await this.api.post<TAdminAppointmentsResponse>(
            API_PREFIX_ADMIN + '/users/appointments',
            payload
        );

        return data;
    }
}
